<template>
  <div class="foreground">    

    <div class="pa-4 text-center">

      <img src="@/assets/img/illustrations/cardboard-box.png" height="100px" width="100px" />

      <div v-if="totalInStock !== 0">
        <c-ms-ii
        :metric_definition="definition" 
        :realValue="totalInStock"
        :key="id"
        alwaysScale
        labelMode
        class="font-weight-bold"
        ></c-ms-ii>
      </div>

      <div v-else class="grey--text">
        Out of stock
      </div>
    </div>

    <table 
    v-if="items.length !== 0"
    class="final-table th-no-padding lines-b pointer hover full-width">
      <colgroup ref="colgroup1">
        <col width="30px">
        <col width="30px">
        <col width="30px">
      </colgroup>

      <tr class="unselectable">
        <c-table-header
        title="RID"
        code="rid"
        class="sticky"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Expiry"
        code="expiry"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>

        <c-table-header
        title="Quantity"
        code="quantity"
        :filters="filters"
        @onClick="clickSortHeader">
        </c-table-header>
      </tr>

      <row
      v-for="item in paginatedArray" 
      :key="item.id"
      :item="item"
      :searchFilters="filters.search"
      @click.native="clickRow(item)"
      @editQuantity="editQuantity"
      ></row>

    </table>

    <!-- NO ITEMS -->
    <div v-if="items.length === 0" class="pa-4">
      No items
    </div>
    <!-- NO ITEMS -->

    <!-- PAGINATION -->
    <c-pagination-client
    :page="page"
    :paginationLength="paginationLength"
    :paginatedArray="paginatedArray"
    :rowsPerPage.sync="rowsPerPage"
    @updatePageNumber="updatePageNumber"
    @goToFirstPage="goToFirstPage"
    @goToPreviousPage="goToPreviousPage"
    @goToNextPage="goToNextPage"
    @goToLastPage="goToLastPage">
    </c-pagination-client>
    <!-- PAGINATION -->

    <!-- DIALOGS -->
    <edit-quantity-dialog ref="editQuantityDialog" @onUpdate="loadAPI"></edit-quantity-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import Row from './row'
import ListController from '@/mixins/ListController'
import CSListItemsPerPage from '@/components/list-server/C-SListItemsPerPage'
import EditQuantityDialog from '@/components/v/inventory/edit-inv-quantity-dialog'
import CTableHeader from '@/components/list-server/th'

export default {
  props: ['id'],
  components: {
    Row,
    CSListItemsPerPage,
    EditQuantityDialog,
    CTableHeader
  },
  mixins: [ListController],
    data () {
    return {
      definition: {},
      filters: {
        rowsPerPage: 10,
        sortCol: 'quantity',
        sortAscending: false,
        date: {
          mainSelect: 'is equal to',
          isInTheLast_select: 'days',
          isInTheLast_input: null,
          date1: null,
          date2: null,
        },
        search: {
          id: '',
          name: ''
        },
        active: {
          customer: false,
          date: false,
          deleted: false
        },
        categories: []
      },
      page: 0,
      currentIndex: 0
    }
  },
  computed: {
    totalInStock () {
      return this.items.reduce((a, b) => +a + +b.quantity, 0)
    }
  },
  watch: {
    id (nv) {
      this.loadAPI()
    }
  },
  methods: {
    editQuantity (id) {
      this.$refs.editQuantityDialog.open(id)
    },
    sort (items) {
      if (this.filters.sortCol === 'rid') {
        return items.sort((a, b) => {
          return this.filters.sortAscending ? a.archive_id - b.archive_id : b.archive_id - a.archive_id
        })
      } else if (this.filters.sortCol === 'expiry') { // Date of entry
        return items.sort((a, b) => {
          return this.filters.sortAscending ? new Date(b.expiry_date) - new Date(a.expiry_date) : new Date(a.expiry_date) - new Date(b.expiry_date)
        })
      } else if (this.filters.sortCol === 'quantity') {
        return items.sort((a, b) => {
          return this.filters.sortAscending ? a.quantity - b.quantity : b.quantity - a.quantity
        })
      }
    },
    loadAPI: _.debounce(function (e) {
      return new Promise((resolve, reject) => {
        this.isLoading = true
        const encodedFilters = btoa(JSON.stringify(this.filters))
        axios.all([
          this.$axios.get(`inventory-definitions/${this.id}`),
          this.$axios.get(`/inventory/definition/${this.id}/?filters=${encodedFilters}&page=${this.page}`)
          ])
          .then(axios.spread((_definition, _inventory) => {
            var rows = _inventory.data.rows
            this.items = rows
            this.definition = _definition.data
          }))
          .then(() => resolve())
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
          .then(() => {
            this.isLoading = false
          })
      })
    }, 150, {leading: true}),
  },
  created () {
    this.loadAPI()
  }
}
</script>